import css from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';
import { createEFPic } from '@/utils/useEFPic';

const { EFPic } = createEFPic('/media/mm100/pc/');

export default function Comp({}: any) {
    const { useLang } = useGlobal();
    const { t } = useLang('ecoflowpowerkitsseries');

    return (
        <div className={`${css.listA} listA`}>
            <div className="kit-inter">
                <div className="kit-l">
                    <EFPic name={['listA.webp', 'listA.jpg']} className="fullImgs" alt="" />
                </div>
                <div className="kit-r">
                    <div className="kit-ms1">{t('presale.product.listA_ms1')}</div>
                    <div className="kit-ms2">{t('presale.product.listA_ms2')}</div>
                </div>
            </div>
        </div>
    );
}
